import { Component, OnInit, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { CmmService } from "../cmm-service.service";

import { PULSE_CMM } from "src/environments/environment";

@Component({
  selector: "dialog-add-property",
  templateUrl: "./dialog-add-property.component.html",
  styleUrls: ["./dialog-add-property.component.scss"]
})
export class DialogAddPropertyComponent implements OnInit {
  dataTypes: any = [
    {
      name: "Texte",
      value: "d:text"
    },
    {
      name: "Nombre",
      value: "d:int"
    },
    {
      name: "Date",
      value: "d:date"
    },
    {
      name: "Booléen",
      value: "d:boolean"
    }
  ];
  selectedType = "";
  slectedRequired = "";
  requireds: any = [
    {
      name: "Obligatoire",
      value: true
    },
    {
      name: "Facultative",
      value: false
    }
  ];

  public description;
  public name;
  public title;
public loading;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DialogAddPropertyComponent>,
    private cmmService: CmmService
  ) {}

  ngOnInit(): void {
  }
  addProperty() {
  
    const data = {
      modelName: PULSE_CMM,
      entityClass: "aspects",
      entityName: this.data.aspectName,
      data: {
        name: this.data.aspectName,
        properties: [
          {
            dataType: this.selectedType,
            defaultValue: "",
            description: this.description,
          //  facetable: FALSE,
            indexed: true,
           // indexTokenisationMode: true,
            mandatory: this.slectedRequired,
            multiValued: false,
            name: this.title.toLowerCase().replace(/[^A-Z0-9]+/ig, "_"),
            title: this.title
          }
        ]
      }
    };

    this.cmmService
      .createProperty(data)
      .then(res => {
      })
      .then(res => {
        this.dialogRef.close(true);
      });
  }
  onCancel() {
    this.dialogRef.close(false);
  }
}
